import { useEffect, useRef } from "react";
import { EvesInsights } from "../components/chat/EvesInsights";
import { PersonalizedGreeting } from "../components/chat/PersonalizedGreeting";
import { Header } from "../components/Header";
import { SessionGuard } from "../components/SessionGuard";
import { useUser } from "../hooks/useUser";
import { useAnalytics } from "../lib/analytics";
import styles from "./HomePage.module.css";

function HomePageContent() {
	const analytics = useAnalytics();
	const hasTrackedPageView = useRef(false);
	const { data: userData, isLoading: userLoading } = useUser();

	useEffect(() => {
		if (!hasTrackedPageView.current) {
			hasTrackedPageView.current = true;
			analytics.logEvent("page_view", "home", {});
		}
	}, [analytics]);

	if (userLoading || !userData) {
		return (
			<div className={styles.container}>
				<Header />
				<main className={styles.main} />
			</div>
		);
	}

	return (
		<div className={styles.container}>
			<Header />
			<main className={styles.main}>
				<PersonalizedGreeting
					user={userData}
					showProgressCircle
					taskCount={3}
				/>
				<EvesInsights />
			</main>
		</div>
	);
}

export function HomePage() {
	return (
		<SessionGuard>
			<HomePageContent />
		</SessionGuard>
	);
}
